import React, { useEffect, useState } from 'react'
import { Box, Flex, Group, Button, Tabs, TextInput, NumberInput, Textarea, Input, Text, Paper, Image } from '@mantine/core'
import { Dropzone } from '@mantine/dropzone'
import { IconPhotoPlus } from '@tabler/icons-react'
import NoImage from '../../../assets/img/images/no-images.png'
import { validation } from '../../../plugins/validation'
import { notificationSuccess, notificationError } from '../../ui/Notifications'
import { addCategory, updateCategory, uploadImage } from '../../../services/category'

const defaultVal = {
  name: '',
  priority: '',
  description: ''
}

const formValidation = {
  name: {
    isError: false,
    message: ''
  },
}

const FormCustomMenuCategories = ({ dataCategory, onCloseForm, reloadList }) => {
  const [loadingForm, setLoadingForm] = useState(false)
  const [selectedTab, setSelectedTab] = useState('form')

  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)

  const [imageUpload, setImageUpload] = useState(null)
  const [imageFile, setImageFile] = useState(null)
  const [recentImage, setRecentImage] = useState(null)

  const submitCustomMenuCategory = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''

    const validateForm = {
      name: form.name,
    }
    
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    const payloadForm = {
      name: form.name,
      priority: form.priority,
      description: form.description,
      level: 1,
      type: 2,
    }
    if (dataCategory !== null) {
      methodFunction = updateCategory(dataCategory.id, payloadForm)
      titleMessageSuccess = 'Update Category Successfully'
      captionMessageSuccess = 'You have been updated data category'
      titleMessageError = 'Update Category Error'
    } else {
      methodFunction = addCategory(payloadForm)
      titleMessageSuccess = 'Add Category Successfully'
      captionMessageSuccess = 'You have been added new category'
      titleMessageError = 'Add Category Error'
    }
    try {
      const response = await methodFunction
      if (response.success) {
        if (imageFile !== null) {
          const uploadImage = await handleUploadPosterCategory(response.data.id, imageFile)
          if (uploadImage.success) {
            notificationSuccess(titleMessageSuccess, captionMessageSuccess)
            onCloseForm()
            reloadList()
          }
        } else {
          notificationSuccess(titleMessageSuccess, captionMessageSuccess)
          onCloseForm()
          reloadList()
        }
        
      } else {
        const responseMessage = response.message
        notificationError(titleMessageError, responseMessage)
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleUploadPosterCategory = async (categoryId, fileImage) => {
    const formData = new FormData()
    formData.append('image', fileImage)
    try {
      const response = await uploadImage(categoryId, formData)
      return response
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your file'
      notificationError('Upload Poster Menu Category Error', captionMessageError)
    }
  }


  useEffect(() => {
    if (dataCategory !== null) {
      handleSetForm(dataCategory)
    }
  }, [dataCategory])

  const handleSetForm = (value) => {
    const detail = {
      name: value.name,
      priority: value.priority,
      description: value.description
    }
    if (value.image) {
      setRecentImage(value.image)
    }
    setFormData(detail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleSelectedImage = () => {
    return imageUpload || recentImage ||NoImage
  }

  const handleUploadImage = (file) => {
    setValidationForm(formValidation)
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      setImageUpload(reader.target.result)
      setImageFile(fileEncoded)
    }
  }

  const handleErrorFile = (file) => {
    setValidationForm(formValidation)
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      const error = {

        image: {
          isError: true,
          message: errorMessage
        }
      }
      setValidationForm(error)
    }
  }

  return (
    <Box>
      <Box>
        <Box mih={550}>
          <Tabs size='xs' my={4} value={selectedTab} onChange={setSelectedTab}>
            <Tabs.List>
              <Tabs.Tab value="form">Menu Category</Tabs.Tab>
              <Tabs.Tab value="poster">Poster</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="form">
              <Box my={10}>
                <Box mb='sm'>
                  <TextInput
                    name='name'
                    value={formData.name}
                    label='Category Name'
                    error={validationForm.name.isError ? `${validationForm.name.message}` : ''}
                    onChange={(val) => handleChangeForm('name', val.target.value)}
                    withAsterisk
                    size='xs'
                  />
                </Box>
                <Box mb='sm'>
                  <NumberInput
                    label="Priority"
                    value={formData.priority}
                    onChange={(val) => handleChangeForm('priority', val)}
                    size='xs'
                  />
                </Box>
                <Box my='sm'>
                  <Textarea
                    name='description'
                    label="Description"
                    placeholder="Input description"
                    value={formData.description}
                    onChange={(val) => handleChangeForm('description', val.target.value)}
                    size='xs'
                    autosize
                    minRows={4}
                    maxRows={4}
                  />
                </Box>
              </Box>
            </Tabs.Panel>
            <Tabs.Panel value="poster">
              <Box my={10}>
                <Box mb={20}>
                  <Input.Wrapper 
                    label='Upload Poster Menu Category' 
                    size='xs' 
                  >
                    <Box my={10}>
                      <Dropzone 
                        accept={[
                          'image/png',
                          'image/jpeg',
                          'image/gif',
                        ]}
                        onDrop={(files) => handleUploadImage(files)}
                        onReject={(files) => handleErrorFile(files)}
                        maxSize={1000000}
                      >
                        <Box ta='center' my={15}>
                          <Flex justify='center' mb={10}>
                            <IconPhotoPlus size={50} color='gray' />
                          </Flex>
                          <Box>
                            <Text fz={12} c='blue.9'>Upload Image Here</Text>
                            <Text fz={12} c='gray.6'>PNG, JPG, GIF up to 1 MB</Text>
                          </Box>
                        </Box>
                      </Dropzone>
                    </Box>
                  </Input.Wrapper>
                </Box>
                <Box>
                  <Text fz={12} fw='500' mb={10}>Recent / Review Poster</Text>
                  <Paper shadow="sm" withBorder radius='md' style={{ backgroundColor: '#f1f2f5' }}>
                    <Flex justify='center'>
                      <Image src={handleSelectedImage()} w='auto' radius='md' h={250} fit='contain' />
                    </Flex>
                  </Paper>
                </Box>
              </Box>
            </Tabs.Panel>
          </Tabs>
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
              <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitCustomMenuCategory(formData)}>{dataCategory !== null ? 'Update' : 'Create'}</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    </Box>
  )
}

export default FormCustomMenuCategories